import { cn } from "@/lib/utils";
import { ReactNode } from "react";

export default function MainGrid({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <section className={cn("py-20 md:py-21", className)}>{children}</section>
  );
}
